import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  Fragment,
} from "react";
import axios from "axios";
import Loading from "../../icons/Loading";
import dispatch from "../../../components/dispatch";

const CancelToken = axios.CancelToken;

import {
  ACTION_CART_READ,
  ACTION_ADDRESS_DETAILS_READ,
  ON_CART_UPDATE,
  LOCAL_PICKUP,
  ACTION_UPDATE_SHIPPING,
  ACTION_SELECT_PICKUP_BRANCH,
  ACTION_BILLING_SUBMIT,
  ACTION_RESET_SHIPPING,
  PICKUP_AVAILABLE,
  PICKUP_IN_STOCK,
  PICKUP_BACK_ORDER,
  ON_CART_CONTENTS_CHANGED,
  SHIPPED,
  OPTION_1,
  ON_ACCOUNT,
  ACCOUNT_TO_ACCOUNT,
  CREDIT_CARD,
  CREDITS, OPTION_2, OPTION_3, OPTION_4,
  EMBROIDERY_WORKS_VAN, LAWRIE_EMBROIDERY_VAN, FREE, SAMPLES, ON_SHIPPING_METHOD_SELECT

} from "../../globals";
import CaretDown from "../../icons/CaretDown";
import Caretup from "../../icons/CaretUP";
import CaretRight from "../../icons/CaretRight";
import addressHTML, { TEXT } from "../../../components/addressHTML";
import moneyFormat from "../../utils/moneyFormat";
import AddressFinderField from "../../utils/AddressFinderField";
import isLoggedIn from "../../../components/isLoggedIn";
import dataLayerHandler from "../../../components/dataLayerHandler";

const SHIPPED_TYPES = [SHIPPED, SAMPLES];
const VAN_TYPES = [EMBROIDERY_WORKS_VAN, LAWRIE_EMBROIDERY_VAN];

const BillingForm = (props) => {

  const [loading, setLoading] = useState(true);
  const [shippingLoading, setShippingLoading] = useState(false);
  const [deliveryLoading, setDeliveryLoading] = useState(false);
  const [cart, setCart] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [countries, setCountries] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [collectingPersonName, setCollectingPersonName] = useState('');
  const [collectingPersonPhone, setCollectingPersonPhone] = useState('');
  const [contactPhone, setContactPhone] = useState(document.querySelector('meta[name="member_phone"]').getAttribute('value'));
  const [name, setName] = useState(document.querySelector('meta[name="member_name"]').getAttribute('value'));

  const [activeIndex, setActiveIndex] = useState(0);
  const [stepProgress, setStepProgress] = useState(0);
  const [shippingError, setShippingError] = useState(false);
  const [pickupError, setPickupError] = useState(false);
  const [guestDataError, setGuestDataError] = useState(false);
  const [paymentError, setPaymentError] = useState(false);

  const [shippingType, setShippingType] = useState(null);
  const [shippingMethod, setShippingMethod] = useState(null);

  const [branch, setBranch] = useState(null);
  const [addressCompany, setAddressCompany] = useState('');

  const [readableAddress, setReadableAddress] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [postCode, setPostCode] = useState('');
  const [country, setCountry] = useState('');
  const [addressBookId, setAddressBookId] = useState(0);
  const [addressAsDefault, setAddressAsDefault] = useState(false);
  const [updateAddress, setUpdateAddress] = useState(false);

  const [guestOrder, setGuestOrder] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');

  const [purchaseOrder, setPurchaseOrder] = useState('');
  const [notes, setNotes] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');

  const [deliveryNotes, setDeliveryNotes] = useState('');
  const [displayTerms, setDisplayTerms] = useState(false);
  const [hideDeliveryOptions, setHideDeliveryOptions] = useState(false);
  const [availableOptions, setAvailableOptions] = useState(null);

  const loggedIn = isLoggedIn();

  const toggleAccordion = (index) => {
    if (stepProgress >= index) {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    axios.get(ACTION_CART_READ).then((response) => {
      const cart = response.data;
      setCart(cart);
      setLoading(false);
    });
    return () => {
    };
  }, []);

  useEffect(() => {
    bindActions();
    loadBillingDetails();
  }, []);

  useEffect(() => {
    if ((cart && cart.guest_order)) {
      setGuestOrder(true);
    }

    if (cart && cart.is_au_site) {
      if (cart.first_name && !firstName) setFirstName(cart.first_name);
      if (cart.surname && !surname) setSurname(cart.surname);
      if (cart.email && !email) setEmail(cart.email);
    }

    if (cart) {
      const branches = cart.branches || [];
      const ew = cart.can_ew || [];
      const le = cart.can_le || [];
      const sample = cart.can_sample || [];

      const count = cart.is_au_site ? 1 : 1 + branches.length + ew.length + le.length + sample.length;
      setHideDeliveryOptions(count === 1);
      if (hideDeliveryOptions && !shippingType) {
        setShippingType(SHIPPED);
        resetShippingMethod();
        setStepProgress(1);
        setActiveIndex(1);
      }
    }
  }, [cart]);

  useEffect(() => {
    if (cart && cart.shipping_options) {
      const availableOptions = Object.entries(cart.shipping_options)
        .filter(([key, option]) => option && typeof option === 'object' && option.can);

      setAvailableOptions(availableOptions);

      if (availableOptions.length === 1) {
        setShippingMethod(availableOptions[0][0]);
      }
    }
  }, [cart]);

  useEffect(() => {
    if (
      shippingMethod &&
      SHIPPED_TYPES.includes(shippingType) &&
      address1 && city && postCode && country
    ) {
      selectShippingMethod();
    }
  }, [shippingMethod]);

  useEffect(() => {
    const parts = [];
    if (address1) {
      parts.push(address1);
    }
    if (address2) {
      parts.push(address2);
    }
    if (city) {
      parts.push(city);
    }
    if (postCode) {
      parts.push(postCode);
    }
    if (country) {
      parts.push(country);
    }
    setReadableAddress(parts.join(', '));
    if (address1 && city && postCode && country) {
      syncShippingDetails();
    }
  }, [address1, address2, city, postCode, country]);


  // useEffect(() => {
  //   if (shippingMethod) {
  //     selectShippingMethod();
  //   }
  // }, [shippingMethod])

  const bindActions = () => {
    window.addEventListener(ON_CART_UPDATE, (e) => {
      setCart(e.data);
    });

    window.addEventListener(ON_CART_CONTENTS_CHANGED, (e) => {
      setCart(e.data);
      setShippingType('');
      setShippingMethod('');
      setBranch(0);
      setActiveIndex(0);
      setStepProgress(0);
    });
  };

  const onShippingSelect = async (e) => {
    const input = e.target;
    if (input.checked) {
      setAddressBookId(0);
      setAddress1('');
      setAddress2('');
      setCity('');
      setPostCode('');
      setCountry('');
      setShippingMethod(null);
      setShippingType(input.getAttribute('data-shipping-type'));
      setBranch(input.getAttribute('data-branch') ? parseInt(input.getAttribute('data-branch')) : 0);
    } else {
      setShippingType(null);
      setBranch(null);
      setShippingMethod(null);
    }
  };

  const onUpdateShippingMethod = async (e) => {
    const input = e.target;
    if (input.checked) {
      setShippingMethod(input.getAttribute('data-method'));
    }
  };

  const validateShipping = (e) => {
    e.preventDefault();
    if (shippingType) {
      resetShippingMethod();
    }
  }

  const validateDeliveryDetails = (e) => {
    e.preventDefault();
    let valid = !!addressCompany
      && address1
      && city
      && postCode
      && country
      && shippingMethod;
    setShippingError(!valid);

    if (valid) {
      setStepProgress(3);
      setActiveIndex(3);

      window.scrollTo({
        top: window.scrollY - 200,
        behavior: "smooth"
      });
    }
  };

  const validatePickupDetails = (e) => {
    e.preventDefault();
    let valid = name
      && contactPhone;

    setPickupError(!valid);

    if (valid) {
      setStepProgress(3);
      setActiveIndex(3);
    }
  }

  const validateGuestData = (e) => {
    e.preventDefault();
    let valid = firstName
      && surname && email;

    setGuestDataError(!valid);

    if (valid) {
      if (shippingType === EMBROIDERY_WORKS_VAN || shippingType === LAWRIE_EMBROIDERY_VAN) {
        setStepProgress(3);
        setActiveIndex(3);
      }
      setStepProgress(2);
      setActiveIndex(2);
    }
  }

  const setAddressFromAddressBook = (e) => {
    const id = e.target.value;
    if (id == 0) {
      setAddressBookId('0');
      setAddress1('');
      setAddress2('');
      setCity('');
      setPostCode('');
      setCountry('');
    } else {
      const address = addresses.find((item) => {
        return item.id == id
      });
      if (address) {
        setAddressCompany(address.company);
        setAddress1(address.address);
        setAddress2(address.address2);
        setCity(address.city);
        setPostCode(address.postcode);
        setCountry(address.country);
        setAddressBookId(id);
      }
    }
  }

  // load the address book and the country list
  const loadBillingDetails = () => {
    axios.get(ACTION_ADDRESS_DETAILS_READ).then((response) => {
      setAddresses(response.data.addresses);
      setCountries(response.data.countries);
    });
  };

  const resetShippingMethod = async () => {
    axios.post(ACTION_RESET_SHIPPING, {
      type: shippingType,
      method: shippingMethod
    }).then((response) => {
      const data = response.data;
      dispatch(ON_SHIPPING_METHOD_SELECT);
      dispatch(ON_CART_UPDATE, data);

      if (guestOrder || cart.is_au_site) {
        setStepProgress(1);
        setActiveIndex(1);
      } else if (VAN_TYPES.includes(shippingType)) {
        setStepProgress(3);
        setActiveIndex(3);
      } else {
        setStepProgress(2);
        setActiveIndex(2);
      }
    });
  };

 const getSubmissionObject = () => {
    return {
      shipping_company: addressCompany,
      shipping_address: address1,
      shipping_address2: address2,
      shipping_city: city,
      shipping_postcode: postCode,
      shipping_country: country,
      type: shippingType,
      method: SHIPPED_TYPES.includes(shippingType) ? shippingMethod : null,
      branch: branch,
      purchase_order: purchaseOrder,
      delivery_notes: deliveryNotes,
      notes: notes,
      update_address: updateAddress,
      set_default: addressAsDefault,
      name: name,
      phone: contactPhone,
      collecting_name: collectingPersonName,
      collecting_phone: collectingPersonPhone,
      first_name: firstName,
      surname: surname,
      email: email,
    };
  };

  const syncShippingDetails = () => {
    setShippingLoading(true);
    const submission = getSubmissionObject();
    if (shippingType === LOCAL_PICKUP) {
      axios
        .post(ACTION_SELECT_PICKUP_BRANCH, submission)
        .then((response) => {
          const data = response.data;
          dispatch(ON_CART_UPDATE, data);
          setShippingLoading(false);
        });
    } else {
      axios.post(ACTION_UPDATE_SHIPPING, submission).then((response) => {
        const data = response.data;
        dispatch(ON_CART_UPDATE, data);
        setShippingLoading(false);
      });
    }
  };

  const selectShippingMethod = () => {
    setDeliveryLoading(true);
    const submission = getSubmissionObject();
    axios.post(ACTION_UPDATE_SHIPPING, submission).then((response) => {
      const data = response.data;
      dispatch(ON_CART_UPDATE, data);
      setDeliveryLoading(false);
    });
  }

  const checkAllData = () => {
    return (
      (
        (shippingType === SHIPPED || shippingType === SAMPLES)
        && address1
        && city
        && postCode
        && country
        && addressCompany
      )
      || (
        shippingType === LOCAL_PICKUP
        && branch
      )
      || (
        shippingType === EMBROIDERY_WORKS_VAN
      )
      || (
        shippingType === LAWRIE_EMBROIDERY_VAN
      )
    )
      && (cart.to_pay === 0 || paymentMethod);
  }

  const submit = (e) => {
    e.preventDefault();
    if (checkAllData()) {
      setProcessing(true);
      setPaymentError(false);

      dataLayerHandler(
        'place_order_click'
      );

      const submission = getSubmissionObject();
      submission['payment_method'] = cart.to_pay ? paymentMethod : ON_ACCOUNT;

      axios.post(ACTION_BILLING_SUBMIT, submission).then((response) => {

        const { hide_redirect, next } = response.data;

        if (hide_redirect) {
          document.getElementById('checkout-order').style.display = 'none';
          document.getElementById('thank-you').style.display = 'block';
          document.getElementById('redirect-msg').style.display = 'none';
          return;
        }

        if (next) {
          if (response.data.next !== "") {
            if (submission['payment_method'] === ON_ACCOUNT) {
              document.getElementById('checkout-order').style.display = 'none';
              document.getElementById('thank-you').style.display = 'block';
              window.setTimeout(() => {
                window.location = response.data.next;
              }, 2000);

            } else {
              window.location = response.data.next;
            }
          }
        }
      });
    } else {
      setPaymentError(true);
    }
  };

  const computeFinalStage = () => {
    if (shippingType === EMBROIDERY_WORKS_VAN || shippingType === LAWRIE_EMBROIDERY_VAN) {
      return guestOrder ? 3 : 2;
    }
    if (hideDeliveryOptions) {
      return 3;
    }
    return guestOrder ? 4 : 3;
  };

  let submitClass = "btn btn--not-bg-icon btn--disabled-default";
  if (paymentMethod) {
    submitClass = "btn btn--not-bg-icon btn--yellow btn--checkout-active";
  }

  if (loading || !cart) {
    return <>
      <div className="card-cart">
        <div className="card-cart__loading">
          <Loading />
        </div>
      </div>
    </>
  }

  return <>
    <div className="checkout-components">
      <div className="checkout-components__accordion">

        {!hideDeliveryOptions &&
          <div className={`card-cart accordion-item ${activeIndex === 0 ? "active" : ""}`}>
            <div
              className={`accordion-title ${activeIndex === 0 ? "active" : ""}`}
              onClick={() => toggleAccordion(0)}
            >
              <h6><span>1.</span>Delivery / Collection</h6>
              {activeIndex === 0 ? <Caretup /> : <CaretDown />}
            </div>

            {activeIndex === 0 && <div className="accordion-content">
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <ul className={"shipping-options"}>
                        <li>
                          <div className={"shipping-options__group"}>
                            <ul>
                              <li>
                                <div className={"shipping-options__radio"}>
                                  <input
                                    type={"radio"}
                                    id={`shipping_shipped`}
                                    checked={shippingType === SHIPPED}
                                    data-branch={0}
                                    data-shipping-type={SHIPPED}
                                    onChange={onShippingSelect}
                                  />
                                </div>
                                <label htmlFor={`shipping_shipped`} className={`shipping-options__content`}>
                                  <strong>Delivery</strong> - Orders over $400.00 are freight free (standard courier)
                                </label>
                              </li>
                              {(cart && cart.branches && cart.branches.length > 0) && <>
                                {cart.branches.map((branchOption) => {
                                  return <li key={`branch_${branchOption.id}`}>
                                    <div className={"shipping-options__radio"}>
                                      <input
                                        type={"radio"}
                                        id={`local_collect_${branchOption.id}`}
                                        checked={shippingType === LOCAL_PICKUP && branchOption.id === branch}
                                        data-branch={branchOption.id}
                                        data-shipping-type={LOCAL_PICKUP}
                                        onChange={onShippingSelect}
                                      />
                                    </div>
                                    <label htmlFor={`local_collect_${branchOption.id}`}
                                      className={"shipping-options__content"}>

                                      {!!branchOption.col_title
                                        ? <div dangerouslySetInnerHTML={{ __html: branchOption.col_title }} />
                                        : `Collect from CLOKE warehouse, ${branchOption.address2}, ${branchOption.city}`}
                                      {cart.can_pickup === PICKUP_IN_STOCK && <p>All in stock</p>}
                                      {cart.can_pickup === PICKUP_AVAILABLE && <p>Available in 2-3 working days</p>}
                                      {cart.can_pickup === PICKUP_BACK_ORDER && <p>Some on backorder</p>}
                                    </label>
                                  </li>
                                })}
                              </>}

                              {!!cart.can_ew && (<li>
                                <div className={"shipping-options__radio"}>
                                  <input
                                    type={"radio"}
                                    id={`shipping_ew`}
                                    checked={shippingType === EMBROIDERY_WORKS_VAN}
                                    data-shipping-type={EMBROIDERY_WORKS_VAN}
                                    data-branch={0}
                                    onChange={onShippingSelect}
                                  />
                                </div>
                                <label htmlFor={`shipping_ew`} className={`shipping-options__content`}>
                                  Embroidery Works Van pick-up
                                </label>
                              </li>)}

                              {!!cart.can_le && (<li>
                                <div className={"shipping-options__radio"}>
                                  <input
                                    type={"radio"}
                                    id={`shipping_le`}
                                    checked={shippingType === LAWRIE_EMBROIDERY_VAN}
                                    data-shipping-type={LAWRIE_EMBROIDERY_VAN}
                                    data-branch={0}
                                    onChange={onShippingSelect}
                                  />
                                </div>
                                <label htmlFor={`shipping_le`} className={`shipping-options__content`}>
                                  Lawrie Embroidery Van pick-up
                                </label>
                              </li>)}

                              {!!(cart.can_sample && cart.available_spent_amount > cart.total_raw) && (
                                <li>
                                  <div className="shipping-options__radio">
                                    <input
                                      type="radio"
                                      id="shipping_samples"
                                      checked={shippingType === SAMPLES}
                                      data-branch={0}
                                      data-shipping-type={SAMPLES}
                                      onChange={onShippingSelect}
                                    />
                                  </div>
                                  <label htmlFor="shipping_samples" className="shipping-options__content">
                                    Sample Order
                                  </label>
                                </li>
                              )}
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                className="btn btn--lightGrey checkout-component__fields__continue"
                onClick={validateShipping}
              >
                <span>CONTINUE</span>
                <CaretRight />
              </button>
            </div>
            }
          </div>}

        {(guestOrder || cart.is_au_site) &&
          <div className={`checkout-component accordion-item ${activeIndex === 1 ? "active" : ""}`}>
            <div
              className={`accordion-title ${activeIndex === 1 ? "active" : ""}`}
              onClick={() => toggleAccordion(1)}
            >
              <h6><span>{cart.is_skinned_site || cart.is_au_site || cart.guest_order ? '1.' : '2.'}</span>Contact Information</h6>
              {activeIndex >= 1 && <>
                {activeIndex === 1 ? <Caretup /> : <CaretDown />}
              </>}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content">
                <div className="checkout-component__body">
                  <div className="checkout-component__field checkout-component__field--full">
                    <label>
                      First name
                    </label>
                    <input
                      type={"text"}
                      name="firstName"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value)
                      }}
                      placeholder="eg: John"
                    />
                  </div>

                  <div className="checkout-component__field checkout-component__field--full">
                    <label>
                      Surname
                    </label>
                    <input
                      type={"text"}
                      name="surname"
                      value={surname}
                      onChange={(e) => {
                        setSurname(e.target.value)
                      }}
                      placeholder="eg: Doe"
                    />
                  </div>

                  <div className="checkout-component__field checkout-component__field--full">
                    <label>
                      Email
                    </label>
                    <input
                      type={"text"}
                      name="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value)
                      }}
                      placeholder="eg: example@example.com"
                    />
                  </div>
                </div>
                <div className={'checkout-component__action-bar'}>
                  {!!guestDataError &&
                    <p className={'checkout-component__err'}>Please ensure first name, surname and email are entered</p>}
                  <div
                    className="btn btn--lightGrey checkout-component__fields__continue"
                    onClick={validateGuestData}>
                    <span>CONTINUE</span>
                    <CaretRight />
                  </div>
                </div>

              </div>
            )}
          </div>}

        {!shippingType && <div className={`checkout-component accordion-item`}>
          <div className={`accordion-title`}>
            <h6><span>{hideDeliveryOptions ? 2 : guestOrder ? 3 : 2}.</span>Select Delivery address & courier options
            </h6>
          </div>
        </div>}

        {shippingType === LOCAL_PICKUP &&
          <div className={`checkout-component accordion-item ${activeIndex === 2 ? "active" : ""}`}>
            <div
              className={`accordion-title ${activeIndex === 2 ? "active" : ""}`}
              onClick={() => toggleAccordion(2)}
            >
              <h6><span>{guestOrder ? 3 : 2}.</span>Collection details</h6>
              {activeIndex >= 2 && <>
                {activeIndex === 2 ? <Caretup /> : <CaretDown />}
              </>}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content">
                <div className="checkout-component__body">
                  <div className="checkout-component__field checkout-component__field--full">
                    <label>
                      Name of person collecting order
                    </label>
                    <input
                      type={"text"}
                      name="name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value)
                      }}
                      placeholder="eg: John"
                    />
                  </div>
                  <div className="checkout-component__field checkout-component__field--full">
                    <label>
                      Contact phone number
                    </label>
                    <input
                      type={"text"}
                      name="phone"
                      value={contactPhone}
                      onChange={(e) => {
                        setContactPhone(e.target.value)
                      }}
                      placeholder=""
                    />
                  </div>
                </div>
                <div className={'checkout-component__action-bar'}>
                  {!!pickupError &&
                    <p className={'checkout-component__err'}>Please ensure name and phone number are entered</p>}
                  <div
                    className="btn btn--lightGrey checkout-component__fields__continue"
                    onClick={validatePickupDetails}>
                    <span>CONTINUE</span>
                    <CaretRight />
                  </div>
                </div>

              </div>
            )}
          </div>}

        {(shippingType === SHIPPED || shippingType === SAMPLES) &&
          <div className={`checkout-component accordion-item ${activeIndex === 2 ? "active" : ""}`}>
            <div
              className={`accordion-title ${activeIndex === 2 ? "active" : ""}`}
              onClick={() => toggleAccordion(2)}
            >
              <h6><span>{hideDeliveryOptions ? 2 : guestOrder ? 3 : 2}.</span>Select Delivery address & courier options
              </h6>
              {activeIndex >= 2 && <>
                {activeIndex === 2 ? <Caretup /> : <CaretDown />}
              </>}
            </div>

            {activeIndex === 2 && (
              <div className="accordion-content">
                <div className="checkout-component__body">
                  <div className="checkout-component__fields">


                    {!guestOrder &&
                      <div className="checkout-component__field">
                        <label>Select Address</label>
                        <select
                          name="address"
                          value={addressBookId}
                          onChange={setAddressFromAddressBook}
                        >
                          <option value='0'>Select Address</option>
                          {addresses.map((addressObj) => (<option key={addressObj.id} value={addressObj.id}>
                            {addressHTML(addressObj, TEXT)}
                          </option>))}
                        </select>
                      </div>
                    }

                    <div className="checkout-component__field checkout-component__field--full">
                      <label>
                        Company name or Person*
                      </label>
                      <input
                        type={"text"}
                        name="shipping_company"
                        value={addressCompany}
                        onChange={(e) => {
                          setAddressCompany(e.target.value)
                        }}
                        placeholder="eg: John"
                      />
                    </div>


                    <div className="checkout-component__field checkout-component__field--full">
                      <label>{addressBookId ? 'Can’t find your address? Add manually' : 'Add new address'}</label>
                      <AddressFinderField
                        value={readableAddress}
                        isAu={cart.is_au_site}
                        onChanged={(v) => {
                          setReadableAddress(v);
                          if (!v) {
                            setAddress1('');
                            setAddress2('');
                            setCity('');
                            setPostCode('');
                            setCountry('');
                            setAddressBookId(0);
                          }
                        }}
                        onSelect={(address) => {
                          setAddress1(`${address.floor ? address.floor : ''} ${address.unit_type ? address.unit_type : ''} ${address.unit_value ? address.unit_value : ''}${address.unit_type || address.unit_value ? ',' : ''} ${address.street_number}${address.street_alpha ? address.street_alpha : ''} ${address.street} ${address.street_type}`);
                          setAddress2(address.suburb);
                          setCity(address.city);
                          setPostCode(address.postcode);
                          setCountry(cart.is_au_site ? 'AU' : 'NZ');
                          setAddressBookId(0);
                        }}
                      />
                    </div>

                    <div className="checkout-component__field checkout-component__field--full">
                      <label>
                        Extra Delivery Instructions
                        (for courier only)
                      </label>
                      <textarea
                        rows={7}
                        name="delivery_notes"
                        autoComplete="nope"
                        value={deliveryNotes}
                        onChange={(e) => {
                          setDeliveryNotes(e.target.value)
                        }}
                      />
                    </div>

                    {loggedIn ? (
                      <div className="checkout-component__field checkout-component__field--full">
                        <ul>
                          <li className={'checkout-component__shipping'}>
                            <input
                              id={'default-address'}
                              type={'checkbox'}
                              checked={addressAsDefault}
                              onClick={() => {
                                setAddressAsDefault(!addressAsDefault)
                              }}
                            />
                            <label htmlFor={'default-address'}>Save address as default</label>
                          </li>
                        </ul>
                      </div>
                    ) : ('')}

                    {availableOptions?.length > 0 && <>
                      <h4>Courier options</h4>

                      {!!shippingLoading && <div>
                        <Loading />
                      </div>}

                      {!shippingLoading && <div className="checkout-component__field checkout-component__field--full">
                        <ul>
                          {(cart.shipping_options.OPTION_1 && cart.shipping_options.OPTION_1.can) &&
                            <li className={'checkout-component__shipping'}>
                              <div>
                                <input
                                  type={'radio'}
                                  data-method={OPTION_1}
                                  checked={shippingMethod === OPTION_1}
                                  onChange={onUpdateShippingMethod}
                                  id={'option_1'}
                                />
                              </div>
                              <label
                                htmlFor={'option_1'}
                              >
                                <strong>{cart.shipping_options.OPTION_1.title} {moneyFormat(cart.shipping_options.OPTION_1.cost)}</strong><br />
                                {cart.shipping_options.OPTION_1.description}
                              </label>
                            </li>}
                          {(cart.shipping_options.OPTION_2 && cart.shipping_options.OPTION_2.can) &&
                            <li className={'checkout-component__shipping'}>
                              <div>
                                <input
                                  id={'option_2'}
                                  type={'radio'}
                                  data-method={OPTION_2}
                                  checked={shippingMethod === OPTION_2}
                                  onChange={onUpdateShippingMethod}
                                />
                              </div>
                              <label
                                htmlFor={'option_2'}
                              >
                                <strong>{cart.shipping_options.OPTION_2.title} {moneyFormat(cart.shipping_options.OPTION_2.cost)}</strong><br />
                                {cart.shipping_options.OPTION_2.description}
                              </label>
                            </li>}
                          {(cart.shipping_options.OPTION_3 && cart.shipping_options.OPTION_3.can) &&
                            <li className={'checkout-component__shipping'}>
                              <div>
                                <input
                                  type={'radio'}
                                  id={'option_3'}
                                  data-method={OPTION_3}
                                  checked={shippingMethod === OPTION_3}
                                  onChange={onUpdateShippingMethod}
                                />
                              </div>
                              <label
                                htmlFor={'option_3'}>
                                <strong>{cart.shipping_options.OPTION_3.title} {moneyFormat(cart.shipping_options.OPTION_3.cost)}</strong><br />
                                {cart.shipping_options.OPTION_3.description}
                              </label>
                            </li>}
                          {(cart.shipping_options.OPTION_4 && cart.shipping_options.OPTION_4.can) &&
                            <li className={'checkout-component__shipping'}>
                              <div>
                                <input
                                  type={'radio'}
                                  id={'option_4'}
                                  data-method={OPTION_4}
                                  checked={shippingMethod === OPTION_4}
                                  onChange={onUpdateShippingMethod}
                                />
                              </div>
                              <label
                                htmlFor={'option_4'}>
                                <strong>{cart.shipping_options.OPTION_4.title} {moneyFormat(cart.shipping_options.OPTION_4.cost)}</strong><br />
                                {cart.shipping_options.OPTION_4.description}
                              </label>
                            </li>}

                          {!!(cart.shipping_options.FREE && cart.shipping_options.FREE.can) &&
                            <li className={'checkout-component__shipping'}>
                              <div>
                                <input
                                  id={'free'}
                                  type={'radio'}
                                  data-method={FREE}
                                  checked={shippingMethod === FREE}
                                  onChange={onUpdateShippingMethod}
                                />
                              </div>
                              <label
                                htmlFor={'free'}>
                                <strong>{cart.shipping_options.FREE.title}</strong>
                              </label>
                            </li>}
                        </ul>
                      </div>}
                    </>}

                  </div>
                </div>
                <div className={'checkout-component__action-bar'}>
                  {!!shippingError && (
                    <p className="checkout-component__err">
                      Please ensure name and address are entered
                      {address1 && availableOptions && availableOptions?.length !== 1 && ", and a courier option is selected"}.
                    </p>
                  )}

                  <div
                    className={`btn btn--lightGrey checkout-component__fields__continue ${deliveryLoading ? 'btn--disabled' : ''}`}
                    onClick={validateDeliveryDetails}>
                    {!!deliveryLoading && <Loading />}
                    {!deliveryLoading && <>
                      <span>CONTINUE</span>
                      <CaretRight />
                    </>}
                  </div>
                </div>
              </div>
            )}
          </div>}

        <div className={`checkout-component accordion-item ${activeIndex === 3 ? "active" : ""}`}>
          <div className={`accordion-title ${activeIndex === 3 ? "active" : ""}`}
            onClick={() => toggleAccordion(3)}>
            <h6><span>{computeFinalStage()}.</span>Place Order</h6>
            {activeIndex >= 3 && <>
              {activeIndex === 3 ? <Caretup /> : <CaretDown />}
            </>}
          </div>
          {activeIndex === 3 && (
            <div className="accordion-content">
              <div className="checkout-component__field checkout-component__field--full">
                <label>Purchase Order Number</label>
                <input
                  type={"text"}
                  name="purchase_order"
                  value={purchaseOrder}
                  onChange={(e) => {
                    setPurchaseOrder(e.target.value)
                  }}
                />
              </div>
              <div className="checkout-component__field checkout-component__field--full">
                <label>Any notes for CLOKE team</label>
                <textarea
                  placeholder="Other notes for CLOKE team"
                  rows={2}
                  name="notes"
                  className="text"
                  value={notes}
                  onChange={(e) => {
                    setNotes(e.target.value)
                  }}
                />
              </div>
              {cart.to_pay > 0 && <table style={{ marginBottom: '20px' }}>
                <tfoot>
                  {cart.can_credits && (
                    <tr className="card-cart__border-0">
                      <td colSpan={2}>
                        <input
                          type={"radio"}
                          id={CREDITS}
                          checked={paymentMethod === CREDITS}
                          onChange={() => {
                            setPaymentMethod(CREDITS)
                          }}
                        />
                        <label htmlFor={CREDITS}>
                          Pay with credits
                          (credits in account:{" "}
                          {credits_left})
                        </label>
                      </td>
                    </tr>
                  )}
                  {cart.can_on_account && (
                    <tr className="card-cart__border-0 account-options">
                      <td colSpan={2}>
                        <input
                          type={"radio"}
                          id={ON_ACCOUNT}
                          checked={paymentMethod === ON_ACCOUNT}
                          onChange={() => {
                            setPaymentMethod(ON_ACCOUNT)
                          }}
                        />
                        <label htmlFor={ON_ACCOUNT}>
                          On Account
                        </label>
                      </td>
                    </tr>
                  )}
                  <tr className="card-cart__border-0 account-options">
                    <td colSpan={2}>
                      <input
                        type={"radio"}
                        id={CREDIT_CARD}
                        checked={paymentMethod === CREDIT_CARD}
                        onChange={() => {
                          setPaymentMethod(CREDIT_CARD)
                        }}
                      />
                      <label htmlFor={CREDIT_CARD}>
                        Credit Card
                      </label>
                    </td>
                  </tr>
                  {!cart.is_au_site &&
                    <tr className="card-cart__border-b account-options">
                      <td colSpan={2}>
                        <input
                          type={"radio"}
                          id={ACCOUNT_TO_ACCOUNT}
                          checked={paymentMethod === ACCOUNT_TO_ACCOUNT}
                          onChange={() => {
                            setPaymentMethod(ACCOUNT_TO_ACCOUNT)
                          }}
                        />
                        <label htmlFor={ACCOUNT_TO_ACCOUNT}>
                          Account-to-Account
                        </label>
                      </td>
                    </tr>
                  }
                </tfoot>
              </table>}

              {(!!cart.checkoutTerms || !!cart.rawHtmlContent) && <p>
                By placing this order you agree to Cloke Clothing Ltd’s <a
                  href={''}
                  target={'_blank'}
                  onClick={(e) => {
                    e.preventDefault();
                    setDisplayTerms(!displayTerms);
                  }}
                >terms and conditions</a>
              </p>}

              <div className={'checkout-component__action-bar'}>
                {!!paymentError && <p className={'checkout-component__err'}>Please select payment method</p>}
                <div className="card-cart">
                  <button
                    className={'btn btn--checkout-active'}
                    style={{ width: '100%' }}
                    onClick={submit}
                  >
                    {!!processing && <Loading />}
                    {!processing && (
                      <>
                        <span>Place order</span>
                        <CaretRight />
                        {props.submit}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {!!(displayTerms && (cart.checkoutTerms || cart.rawHtmlContent)) && <div className={'checkout-page__terms'}>
      <div className="checkout-page__terms__popup">
        <div className="checkout-page__terms__close" onClick={() => {
          setDisplayTerms(false);
        }}>X
        </div>
        <div>
          {!!cart.checkoutTerms && (
            <div dangerouslySetInnerHTML={{ __html: cart.checkoutTerms }} />
          )}
          {!!cart.rawHtmlContent && (
            <div dangerouslySetInnerHTML={{ __html: cart.rawHtmlContent }} />
          )}
        </div>
      </div>
    </div>}

  </>
};
export default BillingForm;
